/**
 * @module sagas/Music.js
 *
 * This file replaces our ActionRouter and currently calls our Promised based
 * middleware workflow functions. Eventually, all Workflows and ActionCreators
 * should themselves be Sagas.
 */

import { fromJS } from 'immutable';
import { all, put, take } from 'redux-saga/effects';

import * as Actions from '../actions';
import ApiActions from '../constants/ApiActions';
import MusicActions from '../constants/MusicActions';
import { tryCall } from '../sagas/Helpers';

import { taskManagerSpawnFactory } from './Helpers/SpawnedTaskManager';
import { getAlbum, getArtist, getLyrics, getTrack } from './workers/Music';

const spawn = taskManagerSpawnFactory();
const LOOP = true;

/**
 * Watch for GET_ARTIST and execute onGetArtist workflow
 */
export function* watchGetArtist() {
  while (LOOP) {
    const action = yield take(MusicActions.GET_ARTIST);
    yield tryCall(getArtist, action);
  }
}

/**
 * Watch for GET_LYRICS and execute onGetLyrics workflow
 */
export function* watchGetLyrics() {
  while (LOOP) {
    const action = yield take(MusicActions.GET_LYRICS);
    yield tryCall(getLyrics, action);
  }
}

/**
 * Watch for GET_TRACK and execute onGetTrack workflow
 */
export function* watchGetTrack() {
  while (LOOP) {
    const action = yield take(MusicActions.GET_TRACK);
    yield tryCall(getTrack, action);
  }
}

/**
 * Watch for GET_ALBUM and execute onGetAlbum workflow
 */
export function* watchGetAlbum() {
  while (LOOP) {
    const action = yield take(MusicActions.GET_ALBUM);
    yield tryCall(getAlbum, action);
  }
}

export function* watchFetchAlbumSuccess() {
  while (LOOP) {
    const action = yield take(ApiActions.FETCH_ALBUM_SUCCESS);
    const albumMusicId = action.response.result;
    const albums = fromJS(action.response.entities.albums);
    const artistSeoToken = albums.getIn([albumMusicId, 'artistSeoToken']);

    if (artistSeoToken && action.getAlbumArtist) {
      yield put(Actions.Music.getArtist(artistSeoToken, false));
    }
  }
}

/**
 * Root Music Saga
 */
export default function* musicSaga() {
  yield all([
    spawn(watchGetArtist),
    spawn(watchGetLyrics),
    spawn(watchGetTrack),
    spawn(watchGetAlbum),
    spawn(watchFetchAlbumSuccess),
  ]);
}
